import { useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { getToken, errText } from "./portalApi";

const AUDIT = `${process.env.REACT_APP_BACKEND_URL}/api/audit/mine`;
const when = (iso) => new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
const summary = (d) => [d.customer_name, d.reason && `Reason: ${d.reason}`, d.text && `“${d.text}”`, d.parcels && `${d.parcels.length} parcel(s)`].filter(Boolean).join(" · ");

export const PortalActivity = () => {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(AUDIT, { headers: { Authorization: `Bearer ${getToken()}` } }).then((r) => setRows(r.data)).catch((e) => { setRows([]); toast.error(errText(e)); });
  useEffect(() => { load(); }, []);
  if (!rows) return <div className="py-10 text-center"><Loader2 className="mx-auto h-5 w-5 animate-spin" /></div>;
  return (
    <div className="rounded-xl border bg-white" data-testid="portal-activity">
      <div className="flex items-center border-b px-4 py-3"><b className="text-sm">Activity log</b><span className="ml-2 text-xs text-slate-400">every change made from this portal</span>
        <button onClick={load} className="ml-auto rounded-lg border p-1.5" data-testid="portal-activity-refresh"><RefreshCw className="h-4 w-4" /></button></div>
      <ul className="divide-y">
        {rows.map((a) => (
          <li key={a.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-2.5 text-sm" data-testid={`portal-activity-${a.id}`}>
            <span className="w-36 shrink-0 text-xs text-slate-500">{when(a.at)}</span>
            <span className={`font-semibold ${a.ok ? "text-slate-800" : "text-rose-600"}`}>{a.action}{!a.ok && " (failed)"}</span>
            <span className="min-w-0 truncate text-xs text-slate-500">{summary(a.details)}</span>
          </li>))}
      </ul>
      {!rows.length && <p className="py-10 text-center text-sm text-slate-400">No activity yet</p>}
    </div>
  );
};
